import { jsxs as l, jsx as C } from "react/jsx-runtime";
function i(e) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "62",
      height: "61",
      viewBox: "0 0 62 61",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M61.2057 19.8732L31.177 10.1053C31.1132 10.0839 31.0431 10.0839 30.9788 10.1053L0.796722 19.7243C0.663818 19.7671 0.573254 19.8898 0.571795 20.0291C0.570325 20.1688 0.658446 20.293 0.789891 20.3382L8.16392 22.865V31.6202C6.92583 32.1762 6.06268 33.4173 6.06268 34.8623C6.06268 36.3073 6.92684 37.5493 8.16392 38.1044L6.2252 50.5892H12.6879L11.0725 38.1044C12.3106 37.5488 13.1737 36.3073 13.1737 34.8623C13.1737 33.4173 12.3105 32.1762 11.0725 31.6202V23.8611L30.8698 30.6446C30.9034 30.6563 30.9389 30.6621 30.974 30.6621C31.009 30.6621 31.0446 30.6568 31.0782 30.6451L61.2091 20.4872C61.3416 20.4424 61.4297 20.3182 61.4287 20.1795C61.4273 20.0393 61.3377 19.9166 61.2057 19.8732H61.2057Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M30.3448 32.1736C30.5468 32.2427 30.7571 32.2788 30.9709 32.2788L30.9707 32.2788C31.1835 32.2788 31.3943 32.2453 31.5944 32.1766L47.8558 26.6946L47.8561 33.8471C48.1853 33.8106 48.5199 33.7919 48.8589 33.7919C53.8294 33.7919 57.8589 37.8213 57.8589 42.7919C57.8589 47.7624 53.8294 51.7919 48.8589 51.7919C44.0674 51.7919 40.1505 48.0476 39.8744 43.3254C37.3517 43.8687 34.3869 44.1818 31.2148 44.1818C22.0236 44.1818 14.5732 41.5537 14.5732 38.3116V26.77L30.3448 32.1736ZM48.8589 38.2919C49.4802 38.2919 49.9839 38.7956 49.9839 39.4169V41.6669H52.2339C52.8552 41.6669 53.3589 42.1706 53.3589 42.7919C53.3589 43.4132 52.8552 43.9169 52.2339 43.9169H49.9839V46.1669C49.9839 46.7882 49.4802 47.2919 48.8589 47.2919C48.2376 47.2919 47.7339 46.7882 47.7339 46.1669V43.9169H45.4839C44.8626 43.9169 44.3589 43.4132 44.3589 42.7919C44.3589 42.1706 44.8626 41.6669 45.4839 41.6669H47.7339V39.4169C47.7339 38.7956 48.2376 38.2919 48.8589 38.2919Z",
            fill: "rgb(var(--text-primary))"
          }
        )
      ]
    }
  );
}
export {
  i as HatWithPlus
};
